import { PathParams, rest } from 'msw'
import {
  PaymentCaseDocumentsResponse,
  PaymentCaseEmailsResponse,
  PaymentCasesResponse,
  PaymentCaseType,
  PaymentsCreateRequest,
  PaymentsCreateResponseError,
  PaymentsResponse,
} from 'types/payments'
import paymentCaseDocumentsMockedResponse from '../../../__mocks__/CaseManagement/paymentCaseDocuments.json'
import paymentCaseEmailsMockedResponse from '../../../__mocks__/CaseManagement/paymentCaseEmails.json'
import paymentCasesMockedResponse from '../../../__mocks__/CaseManagement/paymentCases.json'
import mockCreatePayment from '../../../__mocks__/Payments/createPaymentResponse.json'
import mockPaymentsCreateError from '../../../__mocks__/Payments/errors.json'
import paymentMethods from '../../../__mocks__/Payments/paymentMethods.json'
import mockPayments from '../../../__mocks__/Payments/paymentsResponse.json'

const getAllPayments = rest.get<PaymentsResponse>(
  `${API_URL}/api/v1/pay/ui`,
  async (req, res, ctx) => {
    return res(ctx.json(mockPayments))
  }
)

const validateCryptoAddress = rest.put<PaymentsResponse>(
  `${API_URL}/api/v1/pay/validate`,
  async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json({}))
  }
)

export const getPaymentSupportCases = rest.get<PaymentCasesResponse>(
  `${API_URL}/api/salesforce-facade/v1/case-management/cases`,
  async (req, res, ctx) => {
    const { searchParams } = req.url
    const status = searchParams?.get('status')
    const mockResponse = { ...paymentCasesMockedResponse }

    if (status === PaymentCaseType.NEW) {
      const newCases = mockResponse?.cases?.filter(caseItem => caseItem?.status === status)
      return res(ctx.status(200), ctx.json({ cases: newCases, count: newCases?.length }))
    } else {
      return res(ctx.status(200), ctx.json(paymentCasesMockedResponse))
    }
  }
)

export const getPaymentSupportCasesEmpty = rest.get<PaymentCasesResponse>(
  `${API_URL}/api/salesforce-facade/v1/case-management/cases`,
  async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json([]))
  }
)

export const getPaymentSupportCasesException = rest.get(
  `${API_URL}/api/salesforce-facade/v1/case-management/cases`,
  async (req, res, ctx) => res(ctx.status(400))
)

const getPaymentCaseDocuments = rest.get<PaymentCaseDocumentsResponse>(
  `${API_URL}/api/salesforce-facade/v1/case-management/documents`,
  async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(paymentCaseDocumentsMockedResponse))
  }
)

export const getPaymentCaseDocumentsEmpty = rest.get<PaymentCaseDocumentsResponse>(
  `${API_URL}/api/salesforce-facade/v1/case-management/documents`,
  async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json([]))
  }
)

export const getPaymentCaseDocumentsException = rest.get(
  `${API_URL}/api/salesforce-facade/v1/case-management/documents`,
  async (req, res, ctx) => res(ctx.status(400))
)

const getPaymentCaseEmails = rest.get<PaymentCaseEmailsResponse>(
  `${API_URL}/api/salesforce-facade/v1/case-management/emails`,
  async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(paymentCaseEmailsMockedResponse))
  }
)

export const getPaymentCaseEmailsEmpty = rest.get<PaymentCaseEmailsResponse>(
  `${API_URL}/api/salesforce-facade/v1/case-management/emails`,
  async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json([]))
  }
)

export const getPaymentCaseEmailsException = rest.get(
  `${API_URL}/api/salesforce-facade/v1/case-management/emails`,
  async (req, res, ctx) => res(ctx.status(400))
)

const postCreatePaymentHandler = rest.post<PaymentsCreateRequest, PathParams, PaymentsResponse>(
  `${API_URL}/api/v1/pay/summary`,
  async (req, res, ctx) => {
    return res(ctx.json(mockCreatePayment))
  }
)

export const paymentsHandlerException = rest.post<
  PaymentsCreateRequest,
  PathParams,
  PaymentsCreateResponseError
>(`${API_URL}/api/v1/pay/summary`, async (req, res, ctx) => {
  return res(ctx.status(400), ctx.json(mockPaymentsCreateError))
})

const getPaymentMethods = rest.get(`${API_URL}/api/payment-method`, async (req, res, ctx) => {
  return res(ctx.json(paymentMethods))
})

export const getPaymentMethodsEmpty = rest.get(
  `${API_URL}/api/payment-method`,
  async (req, res, ctx) => {
    return res(ctx.json([]))
  }
)

export default [
  getAllPayments,
  postCreatePaymentHandler,
  getPaymentMethods,
  getPaymentSupportCases,
  getPaymentCaseDocuments,
  getPaymentCaseEmails,
  getPaymentMethodsEmpty,
  validateCryptoAddress,
]
